/**
 * Vestiaire site table. Extensions never hardcode site id / lang / currency;
 * they take a `site` config param validated against SITE_KEYS.
 */
export interface Site {
  siteId: string;
  langCode: string;   // x-lang-code
  language: string;   // x-vc-language
  currency: string;   // x-vc-currency
}

export const SITES = {
  us: { siteId: '6', langCode: 'en_us', language: 'en', currency: 'USD' },
  // TODO: complete from the API / existing extensions, e.g.
  // fr: { siteId: '1', langCode: 'fr_fr', language: 'fr', currency: 'EUR' },
} as const satisfies Record<string, Site>;

export type SiteKey = keyof typeof SITES;
export const SITE_KEYS = Object.keys(SITES) as [SiteKey, ...SiteKey[]];
export const DEFAULT_SITE: SiteKey = 'us';
